<template>
  <div class="SMS">
    <div class="SMS-header">短信管理</div>
    <div class="SMS-main">
      <el-form :inline="true" :model="queryForm">
        <el-form-item label="发送时间" label-width="70px">
          <el-date-picker
            style="width: 220px"
            v-model="queryForm.daterange"
            type="daterange"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleQuery">查询</el-button>
          <el-button @click="resetQuery">重置</el-button>
        </el-form-item>
      </el-form>
      <div class="form-sub">
        <el-button type="primary" plain @click="handleAdd">添加</el-button>
      </div>
      <el-table :data="tableData" style="width: 100%">
        <el-table-column prop="id" label="短信ID" align="center" />
        <el-table-column label="发送时间" align="center" inline-template>
          <div>
            <div>
              {{
                row.sendTime &&
                new Date(row.sendTime).format("yyyy-MM-dd hh:mm:ss")
              }}
            </div>
          </div>
        </el-table-column>
        <el-table-column prop="studentNumber" label="涉及学生" align="center" />
        <el-table-column prop="sendMessage" label="短信" align="center" />
        <el-table-column label="状态" align="center" inline-template>
          <div>
            <div v-if="row.status === 1">未发送</div>
            <div v-if="row.status === 2">已发送（{{ row.smsNumber }}）</div>
          </div>
        </el-table-column>
        <el-table-column
          label="操作"
          align="center"
          width="150"
          inline-template
        >
          <div>
            <el-button
              type="text"
              style="color: #909399"
              @click="handleDetail(row)"
              v-if="row.status === 2"
              >查看</el-button
            >
            <el-button
              type="text"
              @click="handleEdit(row)"
              v-if="row.status === 1"
              >编辑</el-button
            >
          </div>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
          :current-page.sync="queryForm.startIndex"
          :page-size="queryForm.count"
          layout="prev, pager, next, jumper"
          :total="tableTotal"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      queryForm: {
        daterange: [new Date().getTime() - 3600 * 1000 * 24 * 30, new Date()],
        startIndex: 1,
        count: 10,
      },
      tableData: [],
      tableTotal: 0,
    };
  },
  mounted() {
    this.handleQuery();
  },
  methods: {
    handleQuery() {
      const params = {
        sendTimeStart:
          this.queryForm.daterange && this.queryForm.daterange[0]
            ? new Date(this.queryForm.daterange[0]).getTime()
            : "",
        sendTimeEnd:
          this.queryForm.daterange && this.queryForm.daterange[1]
            ? new Date(this.queryForm.daterange[1]).getTime()
            : "",
        startIndex: this.queryForm.startIndex,
        count: this.queryForm.count,
      };
      console.log(params);
      this.$http({
        url: this.$util.domain + "/adminapi/v1/sms/getConfig/list",
        method: "POST",
        dataType: "json",
        body: JSON.stringify({
          ...params,
        }),
      })
        .then((res) => {
          if (res.body.data && JSON.stringify(res.body.data) !== "{}") {
            const { configDTOS, count } = res.body.data;
            this.tableTotal = count || 0;
            if (configDTOS && configDTOS.length) {
              this.tableData = configDTOS;
            }
          } else {
            this.tableData = [];
            this.tableTotal = 0;
            this.$util.errorMsg(res.body.message);
          }
        })
        .catch((error) => {
          this.tableData = [];
          this.tableTotal = 0;
          this.$util.errorMsg("请重试");
        });
    },
    resetQuery() {
      this.queryForm = {
        daterange: [new Date().getTime() - 3600 * 1000 * 24 * 30, new Date()],
      };
      this.handleQuery();
    },
    /**
     * 切换页数
     */
    handleCurrentChange(val) {
      this.queryForm.startIndex = val;
      this.handleQuery();
    },
    handleAdd() {
      this.$router.push({
        path: "/yunying/SMSManage/Detail",
        query: {
          type: "add",
        },
      });
    },
    handleDetail(row) {
      this.$router.push({
        path: "/yunying/SMSManage/Detail",
        query: {
          type: "detail",
          id: row.id,
        },
      });
    },
    handleEdit(row) {
      this.$router.push({
        path: "/yunying/SMSManage/Detail",
        query: {
          type: "edit",
          id: row.id,
        },
      });
    },
  },
};
</script>

<style scoped>
.SMS-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 36px;
  background-color: #eee;
  font-size: 16px;
  padding: 0 30px;
  margin: 20px 0;
}
.SMS-main {
  padding: 0 30px;
}
.form-sub {
  text-align: right;
  margin-bottom: 24px;
}
</style>



// WEBPACK FOOTER //
// index.vue?2965bfb2